import { useMemo } from "react";
import GrainIcon from "@mui/icons-material/Grain";
import { useLocation, useParams } from "react-router-dom";
import { capitalizeFirstLetter } from "utils";
import { BreadcrumbsForRoutes, routes } from "containers/App/Router";
import { useAuth } from "shared/providers/AuthProvider";

const useRouterPathsForBreadcrumbs = (userID, createdBy) => {
  const location = useLocation();
  const params = useParams();
  const path = location.pathname;
  const [, , adminData] = useAuth();

  const pathsForBreadcrumbs = useMemo(() => {
    const splitPath = path.split("/");
    const pathToBreadcrumb = [];
    const allowParams = Object.values(params || {});

    const mappedRoutes = Object.keys(routes).reduce((acc, next) => {
      const pageRoutes = Object.values(routes[next]);
      return acc.concat(pageRoutes);
    }, []);

    let result = splitPath.reduce((acc, path, idx) => {
      pathToBreadcrumb.push(path);

      if (!path) {
        return acc;
      }

      let to = pathToBreadcrumb.join("/");

      const newBreadcrumb = {
        id: idx,
        name: BreadcrumbsForRoutes[to]?.name || capitalizeFirstLetter(path),
        to,
        icon: BreadcrumbsForRoutes[to]?.icon || GrainIcon,
      };

      return [...acc, newBreadcrumb];
    }, []);

    return result.filter((item) => {
      const includesWithParams = item.to.split('?')[0]
        .split("/")
        .some((urlPart) => urlPart && allowParams.includes(urlPart));

      const to = item.to;

      if (adminData?.tenantId) {
        item.to = `${item.to}?tenantId=${adminData.tenantId}`
      }

      return mappedRoutes.includes(to) || includesWithParams;
    });
  }, [adminData?.tenantId, params, path]);

  return { pathsForBreadcrumbs };
};

const routerHooks = {
  useRouterPathsForBreadcrumbs,
};

export default routerHooks;
